import { EMPTY } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { SpreadProfileAction } from '@cbridge-packages/spread-profile';
import { detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { generateSpreadProfileRoute } from '@cbridge-packages/routing-client-admin';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeSpreadProfileBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SpreadProfileAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { id } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    return id === openedDetailsId
      ? [RouterAction.replace([generateSpreadProfileRoute(), withSkipUnsavedChangesConfirmation()])]
      : EMPTY;
  }),
);
